'use strict';
require('arrive'); // eslint-disable-line import/no-unassigned-import
const {autoPlay, Easing, Tween} = require('es6-tween');

const scroll = element => {
	const rect = element.getBoundingClientRect();
	autoPlay(true);

	new Tween({
		x: window.pageXOffset || document.documentElement.scrollLeft,
		y: window.pageYOffset || document.documentElement.scrollTop
	})
		.to({x: rect.left, y: rect.top}, 500)
		.easing(Easing.Cubic.InOut)
		.on('update', obj => window.scrollTo(obj.x | 0, obj.y | 0))
		.start();
};

module.exports.scrollToElement = scroll;

module.exports.scrollToId = hash => {
	try {
		let element = document.querySelector(hash);

		if (element) {
			scroll(element);
		} else {
			document.arrive(hash, () => {
				element = document.querySelector(hash);
				scroll(element);
			});

			setTimeout(() => {
				document.unbindArrive(hash);
			}, 5000);
		}
	} catch (err) {
		console.error(err);
	}
};

module.exports.scrollToClass = hash => {
	try {
		const className = `.${hash.slice(1)}`;
		let element = document.querySelector(className);

		if (element) {
			scroll(element);
		} else {
			document.arrive(className, () => {
				element = document.querySelector(className);
				scroll(element);
			});

			setTimeout(() => {
				document.unbindArrive(className);
			}, 5000);
		}
	} catch (err) {
		console.error(err);
	}
};
